import { render, staticRenderFns } from "./ContactsFragmentDesktopPhotoList.vue?vue&type=template&id=5d9b3c1b&scoped=true&"
import script from "./ContactsFragmentDesktopPhotoList.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentDesktopPhotoList.vue?vue&type=script&lang=js&"
import style0 from "./ContactsFragmentDesktopPhotoList.vue?vue&type=style&index=0&id=5d9b3c1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9b3c1b",
  null
  
)

export default component.exports